/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.QuizMeRpc
 */

export const asyncBulkGenerateQuizMeRpc = {
  serviceName: 'com.hubspot.academy.gen.ai.skills.rpc.QuizMeRpc',
  rpcName: 'asyncBulkGenerateQuizMe',
  auth: 'app',
  fingerprint: 'u-BboNHPwC9a6dfS6rMWgZO0m9sagqtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const asyncBulkGetQuizMeRpc = {
  serviceName: 'com.hubspot.academy.gen.ai.skills.rpc.QuizMeRpc',
  rpcName: 'asyncBulkGetQuizMe',
  auth: 'app',
  fingerprint: 'F0rU8QgGkZMQtz5aAaerFZO0m9sagqtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};